import image from "./painting.jpg";
import image1 from "./painting1.jpg";
import image2 from "./Gstaff_craft.jpg";

export const img = {
  painting: image,
  painting1: image1,
  painting2: image2,
};
